import Image from "next/image";
import DefaultUserFunIcon from "../../../../../../../shared-assets/images/funUgc/DefaultUserFunIcon.png";
import { UGCList } from "../../../../../../models/home-rows";
import styles from "./ProfileDetail.module.scss";

interface ProfileDetailProps {
  ugc: UGCList;
}

export function ProfileDetail({ ugc }: ProfileDetailProps) {
  return (
    <div className={styles.profileWrapper}>
      <div className={styles.profileImageWrapper}>
        <Image
          src={(ugc.user && ugc.user?.avatar) || DefaultUserFunIcon}
          alt=""
          layout="fill"
        />
      </div>
      <div className={styles.profileName}>
        {ugc.user?.nickname ||
          ugc.user?.mobile ||
          ugc.user?.first_name ||
          "ناشناس"}
      </div>
    </div>
  );
}
